import React from 'react'
import { useWeb3React } from '@web3-react/core'
import orderBy from 'lodash/orderBy'
import { Box, Button, Flex, Text } from 'uikit'
import { useTranslation } from 'react-i18next'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { Bet } from 'state/types'
import { fetchNodeHistory } from 'state/predictions'
import { useGetCurrentHistoryPage, useGetHasHistoryLoaded, useGetIsFetchingHistory } from 'state/predictions/hooks'
import HistoricalBet from './HistoricalBet'
import EmptyImg from '../EmptyImg'
// import V1ClaimCheck from '../v1/V1ClaimCheck'

interface RoundsTabProps {
  hasBetHistory: boolean
  bets: Bet[]
}

const RoundsTab: React.FC<RoundsTabProps> = ({ hasBetHistory, bets }) => {
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()
  const hasHistoryLoaded = useGetHasHistoryLoaded()
  const currentHistoryPage = useGetCurrentHistoryPage()
  const isFetchingHistory = useGetIsFetchingHistory()

  const handleClick = () => {
    dispatch(fetchNodeHistory({ account, page: currentHistoryPage + 1 }))
  }

  return hasBetHistory ? (
    <>
      {/* <V1ClaimCheck /> */}
      {orderBy(bets, ['round.epoch'], ['desc']).map((bet) => (
        <HistoricalBet key={bet.round.epoch} bet={bet} />
      ))}
      {hasBetHistory && !hasHistoryLoaded && (
        <Flex alignItems="center" justifyContent="center" py="24px">
          <Button variant="secondary" scale="sm" onClick={handleClick} disabled={isFetchingHistory}>
            {t('PREDICTION_18')}
          </Button>
        </Flex>
      )}
    </>
  ) : (
    <>
      {/* <V1ClaimCheck /> */}
      <Box p="24px">
        <Flex justifyContent="center">
          <EmptyImg margin="60px auto 20px" />
        </Flex>
        <Text fontSize="14px" mb="8px" bold textAlign="center">
          {t('PREDICTION_76')}
        </Text>
        <Text as="p" textAlign="center" fontSize="14px" color="remark">
          {t('PREDICTION_77')}
        </Text>
      </Box>
    </>
  )
}

export default RoundsTab
